<template>
    <div>
        <form method="get">
            <div class="row">
                <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                    <app-select
                        label="Integration Type"
                        placeholder="Integration Type"
                        name="integration-type"
                        id="integration-type"
                        :use-search="false"
                        :is-multiple="false"
                        :options="integrationTypes"
                        v-model="selectedIntegrationType"
                    ></app-select>
                </div>
                <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                    <app-select
                        label="Platform Type"
                        placeholder="Platform Type"
                        name="name"
                        id="filter-name"
                        :use-search="false"
                        :use-select-all="false"
                        :options="platformsOptions"
                        v-model="selectedPlatforms"
                        :max-checked-options="maxCheckedPlatforms"
                        :is-disabled="disabledPlatformsAndMasterTable"
                    ></app-select>
                </div>
                <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                    <app-select
                        label="Table"
                        placeholder="Table"
                        name="table"
                        id="filter-table"
                        :is-multiple="false"
                        :options="masterTablesOptions"
                        v-model="selectedTable"
                        :is-disabled="disabledPlatformsAndMasterTable"
                    ></app-select>
                </div>
                <div class="col-12 mb-md-0 mt-4_5 col-sm-6 col-md-3">
                    <button-set>
                        <app-button
                            type="primary"
                            @click.prevent.default="onSearch"
                            :is-disabled="disabledSearch"
                        >
                            Search
                        </app-button>
                    </button-set>
                </div>
            </div>
        </form>
        <full-page-loader v-if="loading"></full-page-loader>
        <table-platforms
            v-if="platformTables.length > 0"
            :platform-tables="platformTables"
            :master-table="masterTable"
            :master-fields="masterFields"
        ></table-platforms>
    </div>
</template>
<script>
import Table from "./Table";
import route from "ziggy-js";
import debounce from '../../../helpers/debounce'

export const MAX_CHECKED_PLATFORMS = 4;

export default {
    components: {
        'table-platforms': Table
    },
    props: {
        integrationTypes: {
            type: Array,
            default() {
                return [];
            }
        },
        platforms: {
            type: Array,
            default() {
                return [];
            }
        },
        masterTables: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            selectedIntegrationType: '',
            selectedPlatforms: [],
            selectedTable: '',
            masterFields: [],
            masterTable: {},
            platformTables: [],
            loading: false,
            maxCheckedPlatforms: MAX_CHECKED_PLATFORMS
        };
    },
    methods: {
        onSearch: debounce(function () {
            this.loading = true
            axios.post(route('metadata.master-tables.table-platform'), {
                platforms: this.selectedPlatforms,
                table: +this.selectedTable
            }).then(response => {
                this.platformTables = response.data.platformTables;
                this.masterTable = response.data.masterTable;
                this.masterFields = response.data.masterFields;

                this.$notifications.success('The data was received successfully');
                this.loading = false
            }).catch(err => {
                console.error(err.message);
                this.$notifications.error('Error retrieving data');
                this.loading = false
            });
        }, 1000)
    },
    computed: {
        platformsOptions() {
            let options = [];
            this.platforms.forEach(option => {
                if (+this.selectedIntegrationType === option.integration_type_id) {
                    options.push({
                        id: option.id,
                        title: option.connection_type.title,
                    });
                }
            });
            return options;
        },
        masterTablesOptions() {
            let options = [];
            this.masterTables.forEach(option => {
                if (+this.selectedIntegrationType === option.integration_type_id) {
                    options.push({
                        id: option.id,
                        title: option.name,
                    });
                }
            });
            return options;
        },
        disabledPlatformsAndMasterTable() {
            return !Boolean(this.selectedIntegrationType);
        },
        disabledSearch() {
            return !Boolean(this.selectedPlatforms.length) || !Boolean(this.selectedTable);
        }
    }
}
</script>
